/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-actions[_ngcontent-%COMP%]{padding-left:24px;margin-bottom:0}.mat-dialog-title[_ngcontent-%COMP%]{margin-left:0;margin-top:24px}.editReceiptNumberButton[_ngcontent-%COMP%]{width:48px;height:48px}.receiptNumberfield[_ngcontent-%COMP%]{width:240px!important}\n/*# sourceMappingURL=donation-dialog.component.css.map*/"];
export { styles as styles };
